const register_employees_csv =
  'https://res.cloudinary.com/ekincare/raw/upload/v1726650766/sample_csvs/Employees-Registration-1726650353.csv';

const register_employees_xlsx =
  'https://res.cloudinary.com/ekincare/raw/upload/v1726650766/sample_csvs/Employees-Registration-1726650353.xlsx'; 

const deactivate_employees_csv =
  'https://res.cloudinary.com/ekincare/raw/upload/v1637569723/sample_csvs/Employee_deactivation.csv';
  
const deactivate_employees_xlsx =
  'https://res.cloudinary.com/ekincare/raw/upload/v1643887735/sample_csvs/Employee_deactivation.xlsx';
  
const register_family_members_csv =
  'https://res.cloudinary.com/ekincare/raw/upload/v1728973542/sample_csvs/Family-Member-Adddition_4.csv';
 
const register_family_members_xlsx =
  'https://res.cloudinary.com/ekincare/raw/upload/v1733749206/sample_csvs/Family-Member-Adddition_4.xlsx';

const pre_employment_bluk_upload_xlsx =
  'https://res.cloudinary.com/ekincare/raw/upload/v1688492084/sample_csvs/pre_employees_3.xlsx';

const ppmc_bluk_upload_xlsx =
  'https://res.cloudinary.com/ekincare/raw/upload/v1688492084/sample_csvs/pre_employees_3.xlsx';

const team_upload_csv =
  'https://res.cloudinary.com/ekincare/raw/upload/v1680508175/sample_csvs/stepathon_team_upload.csv'

const team_upload_xlsx =
  'https://res.cloudinary.com/ekincare/raw/upload/v1679906567/sample_csvs/stepathon_team_upload.xlsx'

const member_upload_xlsx = 
  'https://res.cloudinary.com/ekincare/raw/upload/v1700484033/sample_csvs/individual_closed_upload_sample-new.xlsx'

const member_upload_csv =
  'https://res.cloudinary.com/ekincare/raw/upload/v1686654257/sample_csvs/individual_closed_upload_sample.csv'

export {
  register_employees_csv,
  register_employees_xlsx,
  deactivate_employees_csv,
  deactivate_employees_xlsx,
  register_family_members_csv,
  register_family_members_xlsx,
  pre_employment_bluk_upload_xlsx,
  team_upload_csv,
  team_upload_xlsx,
  member_upload_xlsx,
  member_upload_csv,
  ppmc_bluk_upload_xlsx
}